package data.datasource.local

import data.datasource.ActionLocalDataSource
import domain.model.ActionCard

class ActionLocalDataSourceImpl : ActionLocalDataSource {
    
    private val localStorage = createLocalStorage()
    
    companion object {
        private const val ACTIONS_KEY = "pr_dashboard_actions"
    }
    
    override fun getActions(): List<ActionCard> {
        return try {
            val actionsJson = localStorage.getString(ACTIONS_KEY)
            if (actionsJson != null) {
                // For simplicity, we'll store a basic format
                // In a real app, you'd use kotlinx.serialization properly
                parseActionsFromJson(actionsJson)
            } else {
                emptyList()
            }
        } catch (e: Exception) {
            emptyList()
        }
    }
    
    override fun saveActions(actions: List<ActionCard>) {
        try {
            val actionsJson = serializeActionsToJson(actions)
            localStorage.setString(ACTIONS_KEY, actionsJson)
        } catch (e: Exception) {
            // Handle error silently for now
        }
    }
    
    private fun parseActionsFromJson(json: String): List<ActionCard> {
        // Simple JSON parsing - in a real app you'd use kotlinx.serialization
        return try {
            val items = json.split("||").filter { it.isNotBlank() }
            items.map { item ->
                val parts = item.split("|")
                if (parts.size >= 4) {
                    ActionCard(
                        id = parts[0],
                        title = parts[1],
                        description = parts[2],
                        url = parts[3]
                    )
                } else {
                    null
                }
            }.filterNotNull()
        } catch (e: Exception) {
            emptyList()
        }
    }
    
    private fun serializeActionsToJson(actions: List<ActionCard>): String {
        // Simple JSON serialization - in a real app you'd use kotlinx.serialization
        return actions.joinToString("||") { action ->
            "${action.id}|${action.title}|${action.description}|${action.url}"
        }
    }
}
